import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Subscription } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { AddServiceComponent } from "src/app/shared/components/add-service/add-service.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "../../../providers/shared.service";
import { FormControl } from "@angular/forms";
import { AddServiceTemplateItemComponent } from "src/app/shared/components/add-service-template-item/add-service-template-item.component";
import { AddServiceTimingsComponent } from "src/app/shared/components/add-service-timings/add-service-timings.component";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/messaging";
import { TranslateService } from "@ngx-translate/core";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { CustomerBookingDetailsComponent } from "src/app/shared/components/customer-booking-details/customer-booking-details.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
@Component({
  selector: "sm-customers-all-bookings",
  templateUrl: "./customers-all-bookings.component.html",
  styleUrls: ["./customers-all-bookings.component.scss"],
})
export class CustomersAllBookingsComponent implements OnInit, OnDestroy {
  entityHashId: string = "";
  phone: string = "";
  name: string = "";
  serviceType: string = "";
  public loader: boolean = false;
  serviceTimings: any = [];
  customerBookingData: any = [];
  serviceList: any[] = [];
  datalength!: number;
  public page: number = 1;
  searchString: FormControl = new FormControl("");
  private _apiSubscription: Subscription;
  daysOfWeek = [
    { day: 1, name: "Sunday" },
    { day: 2, name: "Monday" },
    { day: 3, name: "Tuesday" },
    { day: 4, name: "Wednesday" },
    { day: 5, name: "Thursday" },
    { day: 6, name: "Friday" },
    { day: 7, name: "Saturday" },
  ];

  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "customer_all_bookings.column_headers.date"
      ),
      columnProperty: "booking_date",
    },
    {
      columnName: this.translateService.instant(
        "customer_all_bookings.column_headers.amount"
      ),
      columnProperty: "price",
    },
    {
      columnName: this.translateService.instant(
        "customer_all_bookings.column_headers.status"
      ),
      columnProperty: "bookingStat",
    },
    {
      columnName: this.translateService.instant(
        "customer_all_bookings.column_headers.services"
      ),
      columnProperty: "servicesArray",
    },
    {
      columnName: this.translateService.instant(
        "customer_all_bookings.column_headers.due_amount"
      ),
      columnProperty: "payment_due",
    },
  ];

  constructor(
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private _modelRef: MatDialog,
    private sharedService: SharedService,
    private loaderservice: LoaderServiceService,
    private router: Router,
    private messagingService: MessagingService,
    private angularFireMessaging: AngularFireMessaging,
    private translateService: TranslateService
  ) {
    this._navService.hideSidebarAndNav = false;
    // this.clickEventSubscription = this.sharedService.getClickEvent().subscribe(() => {
    //   this.ngOnInit();
    // })
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this._apiService.getEntityCustomerBookingHistory(
            this.entityHashId,
            this.phone,
            this.page.toString(),
            this.name,
            sessionStorage.getItem("cusphoneforbill")
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        if (resData.result) {
          this._apiService.getEntityCustomerBookingHistory(
            this.entityHashId,
            this.phone,
            this.page.toString(),
            this.name,
            sessionStorage.getItem("cusphoneforbill")
          );
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        if (resData.result) {
          this._apiService.getEntityCustomerBookingHistory(
            this.entityHashId,
            this.phone,
            this.page.toString(),
            this.name,
            sessionStorage.getItem("cusphoneforbill")
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        if (resData.result) {
          this._apiService.getEntityCustomerBookingHistory(
            this.entityHashId,
            this.phone,
            this.page.toString(),
            this.name,
            sessionStorage.getItem("cusphoneforbill")
          );
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_CUSTOMER_BOOKING_HISTORY
      ) {
        this.customerBookingData = [];
        if (resData.result) {
          resData.result.forEach((element: any) => {
            console.log(element);

            if (element.services) {
              if (element.services != null) {
                element.servicesArray = [];
                element.services =
                  typeof element.services == "string"
                    ? JSON.parse(element.services)
                    : element.services;
                element.services.forEach((item: any) => {
                  element.servicesArray.push(" " + item.service_name);
                });
              }
            }
            // if(element.paymentStatus === 0 || !element.paymentStatus){
            //   element.paymentStat = 'Due'
            // }
            // else if(element.paymentStatus == 1){
            //   element.paymentStat = 'Done'
            // }
            // else if(element.paymentStatus == 2){
            //   element.paymentStat = 'Payment in progress'
            // }
            // else if(element.paymentStatus == 3){
            //   element.paymentStat = 'Error in payment'
            // }
            // else {
            //   element.paymentStat = 'N/A'
            // }

            if (
              element.current_status == 0 ||
              element.current_status == 1 ||
              element.current_status == 2
            ) {
              element.bookingStat = "New booking";
            } else if (element.current_status == 3) {
              element.bookingStat = "Under process";
            } else if (element.current_status == 4) {
              element.bookingStat = "Completed";
            } else if (element.current_status == 5) {
              element.bookingStat = "Booking confirmed";
            } else if (element.current_status == 6) {
              element.bookingStat = "Cancelled by User";
            } else if (element.current_status == 7) {
              element.bookingStat = "Assigned";
            } else if (element.current_status == 8) {
              element.bookingStat = "Cancelled by service provider";
            } else if (element.current_status == 9) {
              element.bookingStat = "Partially Complete";
            }

            this.customerBookingData.push(element);
          });
          console.log(this.customerBookingData);
        }
        this.loaderservice.showLoader = false;
      }
    });

    console.log(this.serviceList);
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = ["date", "amount", "status", "services", "due_amount"];

      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `customer_all_bookings.column_headers.${data[index]}`
      );
    });
  }
  // private modelSubscription: Subscription = new Subscription();
  pageTitle: any = "";
  ngOnInit(): void {
    // this.loader = true;
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this.phone = data.phone;
      this.name = data.mn;
      this.pageTitle = "All bookings of " + data.mn;
    });

    // if(this.serviceType == '0'){
    this.loaderservice.showLoader = true;
    this._apiService.getEntityCustomerBookingHistory(
      this.entityHashId,
      this.phone,
      this.page.toString(),
      this.name,
      sessionStorage.getItem("cusphoneforbill")
    );
    // }
    // else if(this.serviceType == '1'){
    //   this.loaderservice.showLoader = true
    //   this._apiService.getShopEntityTimeDetails(this.entityHashId)
    // }
    // this.modelSubscription = this._modelRef.afterAllClosed.subscribe((data) => {
    //   this.loader = true;
    //   this._apiService.getServices(this.entityHashId)
    // });
  }
  openInvoice(item: any) {
    this._modelRef.open(InvoiceForReportComponent, {
      width: "510px",
      data: {
        title: "Invoice",
        ref: this._modelRef,
        data: item.hash_id,
      },
    });
  }
  viewDetails(item: any) {
    // this._modelRef.open(CustomerBookingDetailsComponent, {
    //   width: '700px',
    //   data: {
    //     title: 'Bookings Details',
    //     ref: this._modelRef,
    //     data: item.hash_id,
    //   },
    // });
    this.router.navigate(["booking-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { bookingHash: item.hash_id },
    });
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  onCreateNewService() {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
      },
    });
  }
  onCreateNewServiceFromTemplate() {
    this._modelRef.open(AddServiceTemplateItemComponent, {
      width: "1000px",
      data: {
        title: "Add service From Template",
        ref: this._modelRef,
      },
    });
  }

  openAddTime(rowvalue: any) {
    rowvalue.serviceType = this.serviceType;
    rowvalue.entityHash = this.entityHashId;
    this._modelRef.open(AddServiceTimingsComponent, {
      width: "500px",
      data: {
        title: "Add service timing",
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  removeTime(rowvalue: any) {
    if (this.serviceType == "0") {
      let data = {
        homeServiceTimeInfo: {
          timeList: [
            {
              hashId: rowvalue.hashId,
              status: 2,
            },
          ],
        },
      };
      this._apiService.updateHomeServiceTimeInfo(this.entityHashId, data);
    } else if (this.serviceType == "1") {
      let data = {
        entityTimeInfo: {
          timeList: [
            {
              hashId: rowvalue.hashId,
              status: 2,
            },
          ],
        },
      };
      this._apiService.updateEntityShopTimeInfo(this.entityHashId, data);
    }
  }

  deactivateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 7,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  activateService(rowvalue: any) {
    console.log(rowvalue);
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        status: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  deleteService(rowvalue: any) {
    let metadata = {
      serviceTypeInfo: {
        hash_id: rowvalue.hash_id,
        isDelete: 1,
      },
    };

    this._apiService.addUpdateServiceType(metadata, this.entityHashId);

    // setTimeout(() => {
    //   this.ngOnInit();
    // }, 1500);
  }

  onEdit(rowvalue: any) {
    this._modelRef.open(AddServiceComponent, {
      width: "700px",
      data: {
        title: "Add service",
        type: SM_CONSTANTS.SERVICE_ADD_UPDATE,
        ref: this._modelRef,
        data: rowvalue,
      },
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
    // this.modelSubscription.unsubscribe();
  }

  onPageChange(ev: any) {
    console.log(ev?.pageIndex + 1);
    this.page = ev?.pageIndex + 1;

    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  firstTimeBelow3: boolean = false;

  searchServiceData() {
    if (this.searchString.value.length >= 3) {
      this.firstTimeBelow3 = true;
      this.page = 1;
      this._apiService.getServiceDataByKeyword(
        this.entityHashId,
        this.page,
        this.searchString.value
      );
    } else {
      if (this.firstTimeBelow3) {
        this.firstTimeBelow3 = false;
        this.page = 1;
        // //this._apiService.getServices(this.entityHashId, this.page.toString())
      }
    }
  }

  reset() {
    this.searchString.reset();
    this.page = 1;
    // //this._apiService.getServices(this.entityHashId, this.page.toString())
  }

  convertTo12HourFormat(timeString: any) {
    const [hours, minutes] = timeString.split(":");
    let period = "AM";
    let hour = parseInt(hours, 10);

    if (hour >= 12) {
      period = "PM";
      if (hour > 12) {
        hour -= 12;
      }
    }

    return `${hour.toString().padStart(2, "0")}:${minutes} ${period}`;
  }

  // NEW CODE FOR ROW CLICK
 rowClickHandler = (row: any) => {
  this.viewDetails(row);
};
}
